/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { FlexRow, FlexCol, Select } from 'sarsaparilla';
import PropTypes from 'prop-types';

export default function OptionSelectForm(props) {
    const {
        options,
        selectedOptions,
        isScannedPass,
        reservationPosition,
        submitAttempted,
        onChange,
    } = props;
    if (!options) {
        return null;
    }
    let selectedMap = {};
    if (selectedOptions) {
        selectedMap = selectedOptions.reduce((result, item) => {
            return { ...result, [item.type]: item.value };
        }, {});
    }

    const handleChange = (type, e) => {
        const requiredOptions = options.filter((opt) => opt.is_required);
        const isValid = requiredOptions.reduce((acc, cur) => {
            return (
                acc &&
                (cur.type === type ||
                    (!!selectedMap[cur.type] && selectedMap[cur.type] !== ''))
            );
        }, true);
        onChange({ type, value: e.target.value }, isValid);
    };

    return (
        <FlexRow className={`option-select-form ${isScannedPass ? 'scanned-pass' : ''}`}>
            {options.map((selection) => {
                return (
                    <FlexCol lg={6} key={selection.type}>
                        <Select
                            id={`option-select-${selection.type}-${reservationPosition}`}
                            label={selection.label}
                            isRequired={selection.is_required}
                            placeholder={selection.label}
                            errorText={`${selection.label} is required`}
                            isInvalid={
                                submitAttempted &&
                                selection.is_required &&
                                !selectedMap[selection.type]
                            }
                            options={selection.values}
                            value={selectedMap[selection.type]}
                            onChange={(e) => handleChange(selection.type, e)}
                        />
                    </FlexCol>
                );
            })}
        </FlexRow>
    );
}

OptionSelectForm.propTypes = {
    options: PropTypes.any,
    selectedOptions: PropTypes.any,
    reservationPosition: PropTypes.any,
    submitAttempted: PropTypes.bool,
    onChange: PropTypes.func,
    isScannedPass: PropTypes.bool,
};
